import { FlowNodeBase } from './FlowNodeBase';

interface FlowActionNodeData {
  label: string;
  status: string;
  config: { provider?: string; operation?: string };
}

export function FlowActionNode({
  data,
  selected,
}: {
  data: FlowActionNodeData;
  selected?: boolean;
}) {
  const path = [data.config.provider, data.config.operation].filter(Boolean).join(' / ');
  return (
    <FlowNodeBase
      nodeType="action"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
      description={
        path || (
          // A node nobody has pointed at an action yet. Saying so on the
          // canvas is the point of not seeding a default: the thing left to
          // do is visible without opening the inspector.
          <span className="italic">No action selected</span>
        )
      }
    />
  );
}
